import { gql } from "@apollo/client";
export const EDIT_ORDER = gql`
  mutation editOrder($orderId: ID!, $input: OrderUpdateInput!) {
    editOrder(orderId: $orderId, input: $input) {
      _id
      designId
      printerId
      quantity
      scale
      material
      shippingId
      price
      color
      requestedByUserId
      requestedForUserId
    }
  }
`;

export const UPDATE_ORDER_STATUS = gql`
  mutation updateOrderStatus($orderId: ID!, $status: OrderStatus!) {
    updateOrderStatus(orderId: $orderId, status: $status) {
      _id
      designId
      printerId
      quantity
      scale
      material
      shippingId
      price
      color
      requestedByUserId
      requestedForUserId
    }
  }
`;

export const UPDATE_ORDER_V2 = gql`
  mutation updateOrderV2(
    $orderId: ID!
    $packageId: ID!
    $input: OrderUpdateInput!
  ) {
    updateOrderV2(orderId: $orderId, packageId: $packageId, input: $input) {
      _id
      platformOrderNo
      requestedByUserId
      requestedByUser {
        _id
        firstName
        lastName
        role
      }
      subTotal
      grossTotal
      packages {
        _id
        requestedForUserId
        requestedForUser {
          _id
          firstName
          lastName
          role
        }
        orderType
        deliveryType
        items {
          quantity
          scale
          color
          infill
          material
          printingPrice
          designPrice
          design {
            description
            featuredImage
            name
            images
            design
          }
          designId
          status
          printer {
            name
            length
            height
            width
            postalAddress
          }
          printerId
        }
        shippingDetail {
          from
        }
        shippingPrice
        shippingId
        grossSellerTotal
      }
      shippingDetail {
        to
        overseas
        postServiceCode
        countryCode
        deliveryLocation
        deliveryAddress
      }
      createdAt
      updatedAt
    }
  }
`;
